import { Asset } from 'types'

import PDSAssetTag from 'designSystem/components/PDSAssetTag/PDSAssetTag'
import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSSwitch from 'designSystem/components/PDSSwitch/PDSSwitch'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'
import { formatAsCurrency } from 'utils'

type Props = {
  asset: Asset
  isEditingAsset: boolean
  handleChange: (e: any) => void
  handleDelete: (e: any) => void
  readOnly?: boolean
  showTradableSwitches?: boolean
}

const AssetRowV2 = ({
  asset,
  handleChange,
  showTradableSwitches = false,
}: Props) => {
  const { symbol, price, shares, totalValue, percentageOfPortfolio } = asset
  return (
    <PDSBox
      backgroundColor={COLOR.content}
      border={`1px solid ${COLOR.content_border}`}
      borderRadius={SIZE.s8}
      padding={SIZE.s8}
    >
      <PDSFlexBox alignItems="center">
        <PDSFlexBox flex={1} justifyContent="left">
          <PDSAssetTag symbol={symbol} />
        </PDSFlexBox>
        <PDSFlexBox flex={1} justifyContent="center">
          <PDSText>{formatAsCurrency(price)}</PDSText>
        </PDSFlexBox>
        <PDSFlexBox flex={1} justifyContent="center">
          <PDSText>{shares}</PDSText>
        </PDSFlexBox>
        <PDSFlexBox flex={1} justifyContent="center">
          <PDSText>{formatAsCurrency(totalValue)}</PDSText>
        </PDSFlexBox>
        <PDSFlexBox flex={1} justifyContent="center">
          <PDSText>{percentageOfPortfolio}%</PDSText>
        </PDSFlexBox>
        {showTradableSwitches || (
          <PDSFlexBox flex={1} justifyContent="right" marginTop={SIZE.s4}>
            <PDSSwitch
              checked={asset.tradablePercentage === 1}
              onChange={() =>
                handleChange({
                  name: 'tradablePercentage',
                  value: asset.tradablePercentage === 1 ? 0 : 1,
                })
              }
              testId={`asset-${asset.symbol?.toLocaleLowerCase()}`}
            />
          </PDSFlexBox>
        )}
      </PDSFlexBox>
    </PDSBox>
  )
}

export default AssetRowV2
